import getStore from '../store/store';
import { createDisplayDate } from 'owa-datetime';
import { mutator } from 'satcheljs';
import setStartDate from '../../actions/setStartDate';
import { getStartDate } from '../../selectors/getStoreProperties';
import getEndDateAfterModifications from '../../utils/getEndDateAfterModifications';
/**
 * Function to mutate the start date.
 */
export default mutator(setStartDate, function (actionMessage) {
    var date = actionMessage.date;
    var optionState = getStore().currentState;
    var curStart = getStartDate();
    var startHours = curStart.getHours();
    var startMinutes = curStart.getMinutes();
    // Get the new start date values
    var newStartYear = date.getFullYear();
    var newStartMonth = date.getMonth();
    var newStartDate = date.getDate();
    // Set new start
    var newStart = createDisplayDate(newStartYear, newStartMonth, newStartDate, startHours, startMinutes);
    optionState.startDate = newStart;
    optionState.endDate = getEndDateAfterModifications();
});
//# sourceMappingURL=setStartDate.js.map